var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#056363;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.395,21.167v1.111A2.223,2.223,0,0,1,22.184,24.5H6.711A2.216,2.216,0,0,1,4.5,22.278V6.722A2.216,2.216,0,0,1,6.711,4.5H22.184a2.223,2.223,0,0,1,2.211,2.222V7.833H14.447a2.216,2.216,0,0,0-2.211,2.222v8.889a2.216,2.216,0,0,0,2.211,2.222Zm-9.947-2.222H25.5V10.056H14.447Zm4.421-2.778A1.667,1.667,0,1,1,20.526,14.5,1.66,1.66,0,0,1,18.868,16.167Z",
    transform: "translate(-4.5 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.ea40e6666f19438af8263bb664a22a96.svg";
export { ForwardRef as ReactComponent };